<template lang="pug">
  v-autocomplete(
    v-model="selectedTags"
    chips
    multiple
    cache-items
    deletable-chips
    data-cy="tags-picker"
    background-color="transparent"
    :prepend-inner-icon="icon"
    :class="isProfileV2 ? 'search-v2' : 'search'"
    :disabled="disabled"
    :filter="searchTags"
    :items="tags"
    :search-input.sync='searchTag'
    :label="label"
    :solo="hasTextFieldStyle"
    @keyup.enter="saveSearchTag"
  )
    template(slot="selection" slot-scope="element")
      v-tooltip(
        top
        :disabled="tooltipDisabled(element.item)"
      )
        template(slot="activator")
          v-chip.hotness(
            label
            close
            @input="element.parent.selectItem(element.item)"
          ) {{ element.item | truncate(maxLengthName) }}
        span {{ element.item  }}
    template(slot="item" slot-scope="element")
      v-tooltip(
        top
        :disabled="tooltipDisabled(element.item)"
      )
        template(slot="activator")
          span {{ element.item | truncate(maxLengthName) }}
        span {{ element.item }}
    template(slot='no-data')
      v-card-text.pa-2.elevation-0
        | No results matching #[strong {{ searchTag }}].
        | Press #[strong Enter] to create this tag
</template>

<script>
import { hasMoreItems } from '@/Core/utilities/arrayComparison';
import truncate from '@/Core/filters/truncateText';

export default {
  props: {
    // selected tags
    value: Array,
    disabled: Boolean,
    tagsList: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Tags',
    },
    hasTextFieldStyle: {
      type: Boolean,
      default: false,
    },
    isProfileV2: {
      type: Boolean,
      default: false,
    },
    maxLengthName: {
      type: Number,
      default: 50,
    },
    icon: {
      type: String,
      default: 'local_offer',
    },
  },
  filters: {
    truncate,
  },
  data() {
    return {
      selectedTagsCopy: [],
      // track what the user is entering into input field
      searchTag: '',
    };
  },
  computed: {
    selectedTags: {
      get() {
        this.selectedTagsCopy = [...this.value];
        return this.selectedTagsCopy;
      },
      set(newTag) {
        this.selectedTagsCopy = [...newTag];
        this.$emit('input', this.selectedTagsCopy);
      },
    },
    tags() {
      // we need to concatenate the tags the persisted across pagination
      return [...this.selectedTags, ...this.tagsList];
    },
    isNewSearchTag() {
      const trimmed = this.searchTag ? this.searchTag.trim() : '';
      return trimmed && !this.tags.includes(trimmed);
    },
  },
  watch: {
    // Clears the search value if a new tag is added
    // Do not clear the search value if a tag is removed
    selectedTags(currentTags, prevTags) {
      if (!hasMoreItems(prevTags, currentTags)) this.searchTag = '';
    },
    searchTag(tag) {
      if (!tag) return;
      const searchTerm = tag === '' ? null : `%${tag.trim()}%`;
      this.$emit('update:searchInput', searchTerm);
    },
  },
  methods: {
    /**
     * custom filter for the autocomplete so that extra spaces before & after
     * a search term are trimmed before matching against the list of tags
     */
    searchTags(item, searchTerm) {
      const trimmed = searchTerm.toLowerCase().trim();
      return item.toLowerCase().includes(trimmed);
    },
    // create a tag if it doesn't already exist {
    async saveSearchTag() {
      if (this.isNewSearchTag) {
        this.$emit('save:tag', this.searchTag);
        // need this re-assignment to trigger the computed setter
        this.selectedTags = this.selectedTags.concat(this.searchTag);
      }
    },
    tooltipDisabled(name) {
      return this.maxLengthName > name.length;
    },
  },
};
</script>

<style lang="scss">
.search-v2 {
  .v-input__slot.transparent {
    margin: 0px;
  }
  .v-text-field__details {
    display: none;
  }
  .v-input__slot::before {
    border-color: rgba(0,0,0,0) !important;
  }
  .v-input__prepend-outer, .v-input__append-inner {
    margin-top: 16px;
  }
  .v-chip {
    background: #248B9F;
    color: white;
    border-radius: 2px;
    margin: 4px;
    text-transform: uppercase;
    font-size: 12px;
    .v-chip__content {
      height: 20px;
    }
  }
  .v-chip__close > .v-icon {
    opacity: 1;
  }
}
</style>
